// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"22a26b5d","455":"3c1b4a2e","977":"6b34f18b"}[chunkId] + ".chunk.js";
};